module.exports = __webpack_public_path__ + "img/newsimg.a8f01057.png";